
export default {
    getName: (state) => state.name,
    getNextSeqCode: (state) => state.nextSeqCode,
    getActivities: (state) => state.activities,
}